<template>
  <CreateUpdateTemplate
    :routePreventDialog="routePreventDialog"
    :customClass="'invoice-create'"
    v-if="getPermission('invoice:create')"
  >
    <template v-slot:header-title>
      <h1 class="form-title">
        <v-layout>
          <v-flex class="flex-grow-0"> Invoice For </v-flex>
          <v-flex
            class="m-0 form-title-create-link pl-2"
            link
            :class="{ 'text-truncate': !lodash.isEmpty(customer) }"
          >
            <template v-if="lodash.isEmpty(customer)">Client Name</template>
            <template v-else>{{ customer.display_name }}</template>
            <v-icon
              link
              large
              color="cyan"
              class="mx-2"
              v-if="lodash.isEmpty(customer)"
              >mdi-plus-circle-outline</v-icon
            >
          </v-flex>
        </v-layout>
      </h1>
    </template>
    <template v-slot:header-action>
      <v-btn
        v-on:click="goBack()"
        :disabled="formLoading || pageLoading"
        class="mx-2 custom-grey-border custom-bold-button"
        depressed
      >
        Cancel
      </v-btn>
      <v-btn
        :disabled="!formValid || formLoading || pageLoading"
        :loading="formLoading"
        class="mx-2 custom-bold-button white--text"
        color="cyan"
        v-on:click="updateOrCreate()"
      >
         {{ invoiceCreate.funding_organisation ? 'Save Both Invoice' : 'Save Invoice' }}

      </v-btn>
    </template>
    <template v-slot:body>
      <v-form
        ref="invoiceForm"
        v-model.trim="formValid"
        lazy-validation
        v-on:submit.stop.prevent="updateOrCreate()"
      >
        <perfect-scrollbar
          :options="{ suppressScrollX: true }"
          class="scroll custom-box-top-inner-shadow invoice-create-height"
          style="position: relative"
        >
          <div class="pt-0">
            <v-row>
              <v-col cols="12" v-if="getPermission('invoice:create')">
                <v-container fluid>
                  <v-card flat class="remove-border-radius">
                    <v-card-text ref="overview" class="p-6 font-size-16">
                      <v-row dense>
                        <v-col cols="7" class="pb-0">
                          <div>
                            <label class="font-weight-600 font-size-18 required"
                              >Invoice Title</label
                            >
                            <v-text-field
                              v-model.trim="invoiceCreate.job_title"
                              dense
                              filled
                              label="Title"
                              solo
                              flat
                              :disabled="pageLoading"
                              :loading="pageLoading"
                              v-on:keypress="(e) => manageLimitdescr(e)"
                              v-on:paste="(e) => onPaste(e)"
                              color="cyan"
                              :rules="[
                                validateRules.required(
                                  invoiceCreate.job_title,
                                  'Invoice Title'
                                ),
                                validateRules.minLength(
                                  invoiceCreate.job_title,
                                  'Invoice Title',
                                  1
                                ),
                                validateRules.maxLength(
                                  invoiceCreate.job_title,
                                  'Invoice Title',
                                  100
                                ),
                              ]"
                            ></v-text-field>
                          </div>
                          <div class="text-right">
                            {{
                              invoiceCreate.job_title ? invoiceCreate.job_title.length : 0
                            }}/100
                          </div>

                          <v-layout class="my-4">
                            <v-flex md6 class="mr-2 custom-border-right">
                              <table width="100%">
                                <tr>
                                  <td class="font-weight-600">
                                    <label>Address</label>
                                    <v-icon
                                      class="ml-3"
                                      v-on:click="customerPropertyDialog = true"
                                      color="cyan"
                                      small
                                      >mdi-pencil</v-icon
                                    >
                                    
                                  </td>
                                </tr>
                                <tr>
                                  <td class="py-0">
                                    <label>{{
                                      property?.property_address
                                    }}</label>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="font-weight-600">
                                    <label>Contact details</label>
                                    <v-chip
                                      v-if="property_contact_person?.tenant"
                                      small
                                      color="green white--text"
                                      label
                                      class="ml-2 tenant-small-chip"
                                      >Tenant</v-chip
                                    >
                                    <v-icon
                                      v-if="!invoiceId"
                                      class="ml-3"
                                      v-on:click="
                                        person_type = 'property';
                                        customerPersonDialog = true;
                                      "
                                      color="cyan"
                                      small
                                      >mdi-pencil</v-icon
                                    >
                                  </td>
                                </tr>
                                <tr v-if="property_contact_person.display_name">
                                  <td class="py-0">
                                    <label>{{
                                      property_contact_person.display_name
                                    }}</label>
                                  </td>
                                </tr>
                                <tr
                                  v-if="property_contact_person.primary_phone"
                                >
                                  <td class="py-0">
                                    <label>{{
                                      property_contact_person.primary_phone
                                    }}</label>
                                  </td>
                                </tr>
                                <tr
                                  v-if="property_contact_person.primary_email"
                                >
                                  <td class="py-0">
                                    <label>{{
                                      property_contact_person.primary_email
                                    }}</label>
                                  </td>
                                </tr>
                                <!--<tr>
                                  <td>
                                    <v-layout>
                                      <v-flex
                                        ><label class="font-weight-600">
                                          Email Notification
                                        </label></v-flex
                                      >
                                      <v-flex>
                                        <v-tooltip
                                          top
                                          content-class="custom-top-tooltip"
                                        >
                                          <template
                                            v-slot:activator="{ on, attrs }"
                                          >
                                            <v-switch
                                              class="m-0 p-0"
                                              color="cyan"
                                              dense
                                              v-model="
                                                invoiceCreate.property_person_notify
                                              "
                                              inset
                                            ></v-switch>
                                          </template>
                                          <span
                                            v-if="
                                              invoiceCreate.property_person_notify ==
                                              1
                                            "
                                            >Send Notification</span
                                          >
                                          <span v-else>No Notification</span>
                                        </v-tooltip>
                                      </v-flex>
                                    </v-layout>
                                  </td> 
                                </tr> -->
                              </table>
                            </v-flex>
                            <v-flex md6 class="ml-2">
                              <table width="100%">
                                <tr>
                                  <td class="font-weight-600">
                                    <label>Customer Billing Address</label>
                                    <v-icon
                                      class="ml-3"
                                      v-on:click="customerBillingDialog = true"
                                      color="cyan"
                                      small
                                      >mdi-pencil</v-icon
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td class="py-0">
                                    <label>{{
                                      billing?.property_address
                                    }}</label>
                                  </td>
                                </tr>

                                <tr v-if="fundingOrganisation">
                                  <td class="font-weight-600">
                                    <label>Funding Organisation Billing Address</label>
                                   
                                  </td>
                                </tr>
                                <tr v-if="fundingOrganisation">
                                  <td class="py-0">
                                    <label>{{
                                      funding_billing_address
                                    }}</label>
                                  </td>
                                </tr>

                                <tr>
                                  <td class="font-weight-600">
                                    <label>Contact details</label>
                                    <v-chip
                                      v-if="billing_contact_person?.tenant"
                                      small
                                      color="green white--text"
                                      label
                                      class="ml-2 tenant-small-chip"
                                      >Tenant</v-chip
                                    >
                                    <v-icon
                                      v-if="!invoiceId"
                                      class="ml-3"
                                      v-on:click="
                                        person_type = 'billing';
                                        customerPersonDialog = true;
                                      "
                                      color="cyan"
                                      small
                                      >mdi-pencil</v-icon
                                    >
                                  </td>
                                </tr>
                                <tr v-if="billing_contact_person.display_name">
                                  <td class="py-0">
                                    <label>{{
                                      billing_contact_person.display_name
                                    }}</label>
                                  </td>
                                </tr>
                                <tr v-if="billing_contact_person.primary_phone">
                                  <td class="py-0">
                                    <label>{{
                                      billing_contact_person.primary_phone
                                    }}</label>
                                  </td>
                                </tr>
                                <tr v-if="billing_contact_person.primary_email">
                                  <td class="py-0">
                                    <label>{{
                                      billing_contact_person.primary_email
                                    }}</label>
                                  </td>
                                </tr>
                              <!--<tr>
                                  <td>
                                    <v-layout>
                                      <v-flex
                                        ><label class="font-weight-600">
                                          Email Notification
                                        </label></v-flex
                                      >
                                      <v-flex>
                                        <v-tooltip
                                          top
                                          content-class="custom-top-tooltip"
                                        >
                                          <template
                                            v-slot:activator="{ on, attrs }"
                                          >
                                            <v-switch
                                              class="m-0 p-0"
                                              color="cyan"
                                              dense
                                              v-model="
                                                invoiceCreate.billing_person_notify
                                              "
                                              inset
                                            ></v-switch>
                                          </template>
                                          <span
                                            v-if="
                                              invoiceCreate.billing_person_notify ==
                                              1
                                            "
                                            >Send Notification</span
                                          >
                                          <span v-else>No Notification</span>
                                        </v-tooltip>
                                      </v-flex>
                                    </v-layout>
                                  </td>
                                </tr> -->
                              </table>
                            </v-flex>
                          </v-layout>
                        </v-col>
                        <v-col cols="5" class="pb-0">
                          <table width="100%">
                            <tr>
                              <td width="150" class="font-weight-600">
                                <label>Invoice number</label>
                              </td>
                              <td class="font-weight-700">
                                <label>{{ invoiceCreate.barcode }}</label>
                              </td>
                            </tr>
                            <tr>
                              <td width="150" class="font-weight-600">
                                <label for="reference-no">Reference #</label>
                              </td>
                              <td>
                                <v-text-field
                                  id="reference-no"
                                  v-model.trim="invoiceCreate.reference"
                                  dense
                                  filled
                                  :disabled="pageLoading"
                                  :loading="pageLoading"
                                  color="cyan"
                                  label="Reference #"
                                  :rules="[
                                    validateRules.minLength(
                                      invoiceCreate.reference,
                                      'Reference',
                                      1
                                    ),
                                    validateRules.maxLength(
                                      invoiceCreate.reference,
                                      'Reference',
                                      100
                                    ),
                                  ]"
                                  solo
                                  flat
                                ></v-text-field>
                              </td>
                            </tr>
                            <tr>
                              <td width="150" class="font-weight-600">
                                <label for="issued-date">Invoice date</label>
                              </td>
                              <td>
                                <div
                                  class="d-flex"
                                >
                                  <DatePicker
                                    :pageLoading="pageLoading"
                                    solo
                                    flat
                                    :mandatory="false"
                                    :nullable="true"
                                    placeholder="Invoice date"
                                    v-model="invoiceCreate.invoice_date"
                                  ></DatePicker>
                                  
                                </div>
                               
                              </td>
                            </tr>
                            <tr>
                              <td width="150" class="font-weight-600">
                                <label for="payment-due">Payment due</label>
                              </td>
                              <td>
                                <v-select
                                  id="payment-due"
                                  :items="paymentDueList"
                                  dense
                                  filled
                                  solo
                                  flat
                                  hide-details
                                  :disabled="pageLoading"
                                  v-model.trim="invoiceCreate.payment_due"
                                  placeholder="Payment due"
                                  color="cyan"
                                  item-text="text"
                                  item-value="id"
                                  item-color="cyan"
                                ></v-select>
                              </td>
                            </tr>
                            

                             <tr v-if="invoiceCreate.payment_due == 4">
                              <td width="150" class="font-weight-600">
                                <label for="due-date">Due date</label>
                              </td>
                             
                              <td>
                                <DatePicker
                                  placeholder="Due date"
                                  solo
                                  :mandatory="false"
                                  :nullable="true"
                                  :pageLoading="pageLoading"
                                  v-model="invoiceCreate.due_date"
                                  :min-date="invoiceCreate.invoice_date"
                                ></DatePicker>
                              </td>
                            </tr>

                            <tr>
                              <td width="150" class="font-weight-600">
                                <label for="payment-type">Payment Type</label>
                              </td>
                              <td>
                               
                                <v-autocomplete
                                  :items="paymentTypeList"
                                  dense.
                                  filled
                                  color="cyan"
                                  item-color="cyan"
                                  solo
                                  flat
                                  v-model.trim="invoiceCreate.payment_type"
                                  append-outer-icon="mdi-cog"
                                  placeholder="Payment Type"
                                  v-on:click:append-outer="openPaymentTypeDialog"
                                  item-text="text"
                                  item-value="value"
                                  class="width-100 new-height"
                                  hide-details
                                >
                              <template v-slot:no-data>
                                <v-list-item>
                                  <v-list-item-content>
                                    <v-list-item-title
                                      v-html="'No Payment type(s) Found.'"
                                    ></v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                              </template>
                            </v-autocomplete>
                              </td>
                            </tr>

                            <tr>
                              <td width="150" class="font-weight-600">
                                <label for="funding-organisation">Funding Organisation</label>
                              </td>
                              <td>
                                 <v-autocomplete
                                      :items="fundingOrganisations"
                                      dense.
                                      filled
                                      color="cyan"
                                      item-color="cyan"
                                      solo
                                      flat
                                      v-model.trim="invoiceCreate.funding_organisation"
                                      placeholder="Funding Organisation"
                                      item-text="text"
                                      item-value="value"
                                      class="width-100 new-height"
                                      hide-details
                                      readonly
                                       :disabled="invoiceCreate.payment_type?.toLowerCase().replace(/[-\s]/g, '') === 'selffunded'"
                                      append-icon=""
                                    
                                    >
                                    <template v-slot:no-data>
                                      <v-list-item>
                                        <v-list-item-content>
                                          <v-list-item-title
                                            v-html="'No Funding Organisation(s) Found.'"
                                          ></v-list-item-title>
                                        </v-list-item-content>
                                      </v-list-item>
                                    </template>
                                  </v-autocomplete>
                              </td>
                            </tr>
                            <tr v-if="fundingOrganisation">
                              <td width="150" class="font-weight-600">
                                <label for="contract-period">Contract Period</label>
                              </td>
                              <td>
                                  <v-menu
                                      v-model="datePicker"
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      transition="scale-transition"
                                      offset-y
                                      min-width="290px"
                                    >
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                          dense
                                          filled
                                          flat
                                          label="Transport Date Range"
                                          hide-details
                                          solo
                                          prepend-inner-icon="mdi-calendar"
                                          readonly
                                          v-bind="attrs"
                                         
                                          :value="formattedDate"
                                          color="cyan"
                                        ></v-text-field>
                                      </template>
                                      <v-date-picker
                                        color="cyan"
                                        range
                                        v-model="dates"
                                      ></v-date-picker>
                                   </v-menu>                              
                              </td>

                            </tr>

                              <tr v-if="showContractAlert">
                                <td></td>
                                <td>
                                  <v-card outlined style="background-color: #f9f6ef; border: 1px solid #FFA800;" elevation="0">
                                  <v-card-title class="text-warning">
                                    <v-icon color="warning" left class="mr-2">mdi-alert-circle</v-icon>
                                    No Ongoing Contracts Found
                                  </v-card-title>
                                  <v-card-text class="text-warning">
                                    There are no Ongoing contracts for this customer in the selected Invoice Period. <br />
                                    Please verify customer’s <strong>Funding Organisation</strong>.
                                  </v-card-text>
                                </v-card>


                                </td>
                              </tr>
                             <tr>
                              <td width="150" class="font-weight-600">
                                <label for="customers-copayment-amount">Customer's Copayment Amount</label>
                              </td>
                              <td>
                                  <v-text-field
                                    dense
                                    color="cyan"
                                    filled
                                    type="number"
                                    prepend-inner-icon="mdi-currency-usd"
                                    v-on:keypress="
                                      limitDecimal($event, invoiceCreate.copayment_amount)
                                    "
                                    v-model="invoiceCreate.copayment_amount"
                                    v-model.trim.number.lazy="invoiceCreate.copayment_amount"
                                    placeholder="Copayment Amount"
                                    solo
                                    flat
                                    hide-details
                                    readonly

                             ></v-text-field>
                                
                              </td>
                            </tr>

                             <tr v-if="invoiceCreate.funding_organisation?.toLowerCase() === 'nkf'">
                              <td width="150" class="font-weight-600">
                                <label for="customers-copayment-amount">Pro-rated Copayment Amount</label>
                              </td>
                              <td>
                                 <v-text-field
                                    dense
                                    color="cyan"
                                    filled
                                    type="number"
                                    prepend-inner-icon="mdi-currency-usd"
                                    v-on:keypress="
                                      limitDecimal($event, invoiceCreate.pro_rated_copayment_amount)
                                    "
                                    v-model="invoiceCreate.pro_rated_copayment_amount"
                                    v-model.trim.number.lazy="invoiceCreate.pro_rated_copayment_amount"
                                    placeholder="Pro-rated Copayment Amount"
                                    solo
                                    flat
                                    hide-details
                                    :readonly="invoiceCreate.consolidated_trips !== 13"

                             ></v-text-field>
                              </td>
                            </tr>

                             <tr>
                              <td width="150" class="font-weight-600">
                                <label for="consolidated_no_of_trips">Consolidated No. of Trips</label>
                              </td>
                              <td>
                                 <v-text-field
                                    dense
                                    color="cyan"
                                    filled
                                    type="number"
                                    v-on:keypress="
                                      limitDecimal($event, invoiceCreate.consolidated_trips)
                                    "
                                    v-model="invoiceCreate.consolidated_trips"
                                    v-model.trim.number.lazy="invoiceCreate.consolidated_trips"
                                    readonly
                                    solo
                                    flat
                                    hide-details
                             ></v-text-field>
                              </td>
                            </tr>

                           
                          </table>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-container>
              </v-col>
              <v-col cols="12" v-if="getPermission('line-item:create')">
                <v-container fluid>
                  <v-card flat class="custom-grey-border remove-border-radius">
                    <v-card-title class="headline grey lighten-4">
                      <h3
                        class="font-weight-700 custom-headline color-custom-blue"
                      >
                        Line Items
                      </h3>
                    </v-card-title>
                    <v-card-text ref="lineItem" class="p-6 font-size-16">
                      <v-row dense>
                        <v-col cols="12" class="pt-0 pb-0">
                          <InvoiceLineItemNew
                            :subtotal.sync="subtotal"
                            is-invoice
                            :transports="invoiceId ? [] : selectedTransports"
                            :item-set="false"
                            :related-type="related_type"
                            :related-detail="invoiceData"
                            :key="`invoice-line-item-${uniqueId}`"
                            module-type="invoice"
                            :invoice="invoiceCreate"
                            
                          ></InvoiceLineItemNew>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-container>
              </v-col>
              <v-col cols="12">
                <InvoicePaymentTerms
                  :update-data="updateData"
                  :pageLoading="pageLoading"
                ></InvoicePaymentTerms>
              </v-col>
              <v-col cols="12">
                <InvoiceTermsConditions
                  :update-data="updateData"
                  :page-loading="pageLoading"
                ></InvoiceTermsConditions>
              </v-col>
              <v-col cols="12">
                <InvoiceNotesAttachment
                  :update-data="updateData"
                  :page-loading="pageLoading"
                ></InvoiceNotesAttachment>
              </v-col>
            </v-row>
          </div>
        </perfect-scrollbar>
      </v-form>
      <template v-if="customerPersonDialog">
        <CustomerPersonDialog
          disabled-auto-select
          :customerPersonDialog="customerPersonDialog"
          :customer="customer.id"
          v-on:close="closeDialog"
          v-on:selectCustomerPerson="selectCustomerPerson"
        ></CustomerPersonDialog>
      </template>
      <template v-if="customerPropertyDialog">
        <CustomerPropertyDialog
          disabled-auto-select
          :customerPropertyDialog="customerPropertyDialog"
          :customer="customer.id"
          v-on:close="closeDialog"
          v-on:selectCustomerProperty="selectCustomerProperty"
        ></CustomerPropertyDialog>
      </template>
      <template v-if="customerBillingDialog">
        <CustomerBillingDialog
          disabled-auto-select
          :customerBillingDialog="customerBillingDialog"
          :customer="customer.id"
          :supplier="supplierId"
          v-on:close="closeDialog"
          v-on:selectCustomerBilling="selectCustomerBilling"
        ></CustomerBillingDialog>
      </template>
      <template v-if="managePaymentType">
          <ManagePaymentCategory
            :d-dialog="managePaymentType"
            :e_payment_categories ="paymentTypeList"
            v-on:close-dialog="managePaymentType = false"
            v-on:get-e-payment-categories="getOptions"
          ></ManagePaymentCategory>
      </template>
    </template>
  </CreateUpdateTemplate>
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";
import ValidationMixin from "@/core/plugins/validation-mixin";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import CreateUpdateTemplate from "@/view/pages/partials/Create-Update-Template.vue";
import { PreventDialogEventBus } from "@/core/lib/prevent.reload.lib";
import { QUERY, POST, PUT } from "@/core/services/store/request.module";
import CustomerPersonDialog from "@/view/pages/partials/Select-Customer-Person.vue";
import CustomerPropertyDialog from "@/view/pages/partials/Select-Customer-Property.vue";
import CustomerBillingDialog from "@/view/pages/partials/Select-Customer-Billing.vue";
import InvoiceLineItemNew from "@/view/pages/partials/Line-Item-V2.vue";
import LineItemMixin from "@/core/lib/line-item/line.item.mixin";
import { ErrorEventBus, InitializeError} from "@/core/lib/message.lib"; 
import { TermConditionEventBus } from "@/core/lib/term.condition.lib";
import { NoteAttachmentEventBus } from "@/core/lib/note.attachment.lib";
import InvoicePaymentTerms from "@/view/pages/partials/Payment-Terms.vue";
import InvoiceTermsConditions from "@/view/pages/partials/Terms-Conditions.vue";
import InvoiceNotesAttachment from "@/view/pages/partials/Notes-Attachment.vue";
import { filter, isEmpty, toSafeInteger} from "lodash";
import DatePicker from "@/view/components/DatePicker";
import ManagePaymentCategory from "@/view/pages/partials/Manage-Payment-Category.vue";
import { mapGetters } from "vuex";



export default {
  mixins: [CommonMixin, ValidationMixin, LineItemMixin],
  name: "invoice-create",
  title: "Create Invoice",
  data() {
    return {
      funding_billing_address : null,
      showContractAlert : false,
      isUpdate : false,
      showNoContractMessage : false,
      companyVisit : false,
      related_type : 2,
      updatetedInvoice : {},
      uniqueId: Number(new Date()),
      managePaymentType :false,
      formLoading: false,
      pageLoading: false,
      invoiceCreated: false,
      lineItemCreated: false,
      fundingOrganisations : [],
      selectedTransports : [],
      transportLineItems : [],
      customer: {},
      supplierId : 0,
      property: {},
      billing: {},
      barcodeSetting: {},
      invoiceData : {},
      datePicker: false,
      dates: {
        start: null,
        end: null
      },
      invoiceCreate: {
        job_title: null,
        property_person_notify: 1,
        billing_person_notify: 1,
        reference: null,
        issued_type: 0,
        payment_due: "1",
        discount_value: null,
        discount_value_type: 1,
        tax_applied: null,
        adjustment: null,
        invoice_date: new Date().toISOString().split('T')[0],
        attention: null,
        payment_type :null,
        funding_organisation : null,
        funding_group_id : 0,
        copayment_amount : null,
        copayment_amount_type : 1,
        pro_rated_copayment_amount : null,
        consolidated_trips : null,
        contract_start_date : null,
        contract_end_date : null,
        copayment_perc : 0
  
      },
      subtotal : 0,
      customerPersonDialog: false,
      customerBillingDialog: false,
      customerPropertyDialog: false,
      customerPerson: 0,
      customerProperty: 0,
      customerBilling: 0,
      person_type: null,
      ticketId: null,
      visitId: null,
      invoiceId: null,
      quotationId: null,
      property_contact_person: {},
      billing_contact_person: {},
      lineItem: [],
      equipments: [],
      dbLineItems: [],
      dbEquipments: [],
      paymentDueList: [],
      noteAttachment: {},
      termsCondition: null,
      paymentTerms: null,
      lineItemCalculation: {
        taxApplied: 0,
        discountValue: 0,
        adjustmentAmount: 0,
        discountType: 1,
        discountValueType: 0,
      },
      updateData: {
        payment_terms: null,
        term_conditions: null,
        admin_remark: null,
        client_remark: null,
        notify_admin: 0,
        notify_customer: 0,
        notify_engineer: 0,
        documents: [],
      },
      paymentTypeList:[],
      copaymentTypeList: [
        { type: "$", value: 1 },
        { type: "%", value: 2 },
      ],
    };
  },
  components: {
    DatePicker,
    CustomerPersonDialog,
    CustomerPropertyDialog,
    CustomerBillingDialog,
    InvoiceLineItemNew,
    CreateUpdateTemplate,
    InvoicePaymentTerms,
    InvoiceTermsConditions,
    InvoiceNotesAttachment,
    ManagePaymentCategory
  },
  methods: {

      onPaste(e) {
      let coppied = e.clipboardData.getData("Text");
      let preVal = this.invoiceCreate.job_title;
      let finalval = String(preVal) + String(coppied);
      if (Number(finalval.length) > 99) {
        let trimValue = finalval.substring(0, 100);
        this.invoiceCreate.job_title.length = trimValue;
        e.preventDefault();
      }
    },

     formatDate(dateStr) {
      const date = new Date(dateStr);
      return date.toLocaleDateString('en-GB'); 
    },

    updateCopaymentAmount(total)
    {

      
      if(this.invoiceCreate.funding_organisation && this.invoiceCreate.copayment_amount_type == '2')
      {
         
          const percentage = this.invoiceId > 0 ? this.invoiceCreate.copayment_perc : this.fundingOrganisation.copayment_amount;
          const subTotal = parseFloat(total) || 0;
          const copayment_amount = (percentage / 100) * subTotal;
          this.invoiceCreate.copayment_amount = parseFloat(copayment_amount.toFixed(2));
          
      }

    },

    manageLimitdescr(e) {
      if (
          this.invoiceCreate.job_title &&
          this.invoiceCreate.job_title.length > 99
        ) {
          e.preventDefault();
        }
      },

      getInvoiceLineItems() {

      this.pageLoading = true;
      const transportIds = this.selectedTransports.map(transport => transport.id);
      this.$store
        .dispatch(QUERY, {
          url: "invoice/transport-line-items",
          data: {
            transports : transportIds,
          },
        })
        .then(({ data }) => {
        
         this.invoiceLine = data;
         
        })

        .catch((error) => {
          this.logError(error);

        })
        .finally(() => {
          this.pageLoading = false;
        });
    },

    
    updateLineItem(rows) {
      this.lineItem = rows;
    },
    updateEquipment(rows) {
      this.equipments = rows;
    },

    openPaymentTypeDialog() {

      this.managePaymentType = true;
      this.getOptions();
      
    },

  
    updateLineItemCalculation(row) {
      this.lineItemCalculation.taxApplied = row.apply_tax;
      this.lineItemCalculation.discountValue = row.discount_value;
      this.lineItemCalculation.adjustmentAmount = row.adjustment;
      this.lineItemCalculation.discountType = 1;
      this.lineItemCalculation.discountValueType = row.discount_value_type;
    },
    routeToServiceHistory() {
      this.forcePush = true;
      this.$nextTick(() => {
        this.$router.push(
          this.getDefaultRoute("property.detail", {
            params: { id: this.property.id },
            query: {
              tab: "property-history",
            },
          })
        );
      });
    },
    closeDialog() {
      this.customerPersonDialog = false;
      this.customerBillingDialog = false;
      this.customerPropertyDialog = false;
    },
    selectCustomerPerson(param) {
      if (this.person_type == "property") {
        if (this.invoicePropertyPerson == param.id) {
          this.closeDialog();
          return false;
        }
        this.property_contact_person = param;
        this.invoicePropertyPerson = param.id;
      }
      if (this.person_type == "billing") {
        if (this.invoiceBillingPerson == param.id) {
          this.closeDialog();
          return false;
        }
        this.billing_contact_person = param;
        this.invoiceBillingPerson = param.id;
      }
      this.closeDialog();

    },
    selectCustomerProperty(param) {

      if (this.invoiceProperty == param.id) {
        this.closeDialog();
        return false;
      }

      this.invoiceProperty = param.id;
      this.property = param;
      this.closeDialog();
     
    },
    selectCustomerBilling(param) {
      if (this.invoiceBilling == param.id) {
        this.closeDialog();
        return false;
      }
      this.invoiceBilling = param.id;
      this.billing = param;
      this.closeDialog();

    },
    pushToRouteInvoice() {
      this.$router
        .replace(
          this.getDefaultRoute("invoice.create", {
            query: {
              customer: this.invoiceCustomer,
              billing: this.invoiceBilling,
              property: this.invoiceProperty,
              property_person: this.invoicePropertyPerson,
              billing_person: this.invoiceBillingPerson,
              duplicate: this.duplicateInvoice,
              quotation: this.quotationId,
              ticket: this.ticketId,
              visit: this.visitId,
            },
          })
        )
        .then(() => {
          this.getOptions();
        });
    },
    async updateOrCreate(type) {

      const _this = this;

      const validateStatus = _this.$refs.invoiceForm.validate();

      const formErrors = _this.validateForm(_this.$refs.invoiceForm);

      if (formErrors.length) {
        for (let i = 0; i < formErrors.length; i++) {
          ErrorEventBus.$emit("update:error", InitializeError(formErrors[i]));
        }
        return false;
      }

       const calc = this.vCalculations || {};

       const line_items =  this.vSelectedLineItem;
      
  
      if (line_items.length === 0) {
        ErrorEventBus.$emit(  
          "update:error",
          InitializeError("Select Line Item.")
        );
        return false;
      }

      if (!validateStatus) {
        return false;
      }

      let REQUEST_TYPE = POST;
      let REQUEST_URL = "invoice";

      if (_this.invoiceId && _this.invoiceId > 0) {
        REQUEST_TYPE = PUT;
        REQUEST_URL = "invoice/" + _this.invoiceId;
        
      }

       _this.formLoading = true;

      const formData = new Object({
        action: typeof type == "string" ? type : undefined,
        reference: _this.invoiceCreate.reference,
        customer: _this.invoiceCustomer,
        property: _this.invoiceProperty,
        billing: _this.invoiceBilling,
        property_contact_person: _this.invoicePropertyPerson,
        billing_contact_person: _this.invoiceBillingPerson,
       
        title: _this.invoiceCreate.job_title,
        quotation: _this.quotationId,
        ticket: _this.ticketId,
        visit: _this.visitId,
        attention: _this.invoiceCreate.attention,
        admin_remark: _this.noteAttachment.admin_notes,
        client_remark: _this.noteAttachment.client_notes,
        term_conditions: _this.termsCondition,
        payment_terms: _this.paymentTerms,
        tax_applied: calc.tax_active === true ? 1 : 0,
        discount_value: calc.discount_value ? parseFloat(calc.discount_value) : 0,
        discount_type: calc.discount_level && calc.discount_level === 'transaction' ? 1 : 2,
        discount_value_type: calc.discount_type ? parseInt(calc.discount_type) : 0,
        tax_value: calc.tax_value ? parseFloat(calc.tax_value) : 0,
        show_price: calc.show_price && calc.show_price === true ? 1 : 0,
        adjustment: calc.adjustment ? parseFloat(calc.adjustment) : 0,
        ctx_discount_label: calc.ctx_discount_label ? String(calc.ctx_discount_label) : null,
        ctx_discount_value: calc.ctx_discount_value && calc.ctx_discount_value !== '' ? parseFloat(calc.ctx_discount_value) : 0,
        ctx_discount_type: calc.ctx_discount_type ? parseInt(calc.ctx_discount_type) : 0,
        property_person_notify: toSafeInteger(
          _this.invoiceCreate.property_person_notify
        ),
        billing_person_notify: toSafeInteger(
          _this.invoiceCreate.billing_person_notify
        ),
        issued_type: _this.invoiceCreate.issued_type,
        payment_due: _this.invoiceCreate.payment_due,
        invoice_date: _this.invoiceCreate.invoice_date,
        due_date: _this.invoiceCreate.due_date,
        documents: _this.noteAttachment.documents,
        payment_type : _this.invoiceCreate.payment_type,
        funding_organisation : _this.invoiceCreate.funding_organisation,
        contract_start_date : _this.invoiceCreate.contract_start_date,
        contract_end_date : _this.invoiceCreate.contract_end_date,
        copayment_amount : _this.invoiceCreate.copayment_amount,
        copayment_amount_type : _this.invoiceCreate.copayment_amount_type,
        copayment_perc : _this.invoiceCreate.copayment_perc,
        consolidated_trips :  _this.invoiceCreate.consolidated_trips,
        funding_group_id : _this.invoiceCreate.funding_group_id,
        pro_rated_copayment_amount : _this.invoiceCreate.pro_rated_copayment_amount,
        line_items : line_items,
        transports : _this.selectedTransports
      });

      if (!_this.invoiceCreated) {
        try {
          const invoice = await _this.$store.dispatch(REQUEST_TYPE, {
            url: REQUEST_URL,
            data: formData,
          });

          if (!isEmpty(invoice)) {
            _this.invoiceId = toSafeInteger(invoice.data.id);
            _this.invoiceCreated = true;
          }
        } catch (error) {
          _this.logError(error);
          _this.formLoading = false;
          ErrorEventBus.$emit(
            "update:error",
            InitializeError("Invoice is not created. Please try again.")
          );
          return false;
        }
      }

      _this.formLoading = false;

      _this.$nextTick(() => {
        _this.$router.push( _this.getDefaultRoute("invoice"));
      });

    },

    getLineItems(data) {
      const _this = this;
      return new Promise((resolve, reject) => {
        _this.$store
          .dispatch(QUERY, {
            url: "line-item/new",
            data,
          })
          .then(({ data }) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    setUpdateData(param) {
      const _this = this;
      _this.invoiceData = param;

      _this.invoiceCreate.job_title = param.title;
      _this.invoiceCreate.property_person_notify = param.property_person_notify;
      _this.invoiceCreate.billing_person_notify = param.billing_person_notify;
      _this.invoiceCreate.reference = param.reference;
      _this.invoiceCreate.issued_type = param.issued_type;
      _this.invoiceCreate.payment_due = param.payment_due;
      _this.invoiceCreate.discount_value = param.discount_value;
      _this.invoiceCreate.discount_value_type = param.discount_value_type;
      _this.invoiceCreate.tax_applied = param.tax_applied;
      _this.invoiceCreate.adjustment = param.adjustment;
      _this.invoiceCreate.invoice_date = param.invoice_date;
      _this.invoiceCreate.due_date = param.due_date;
      _this.invoiceCreate.attention = param.attention;
      _this.invoiceCreate.payment_type = param.payment_type;
      _this.invoiceCreate.funding_organisation = param.funding_organisation;
      _this.invoiceCreate.contract_start_date = param.contract_start_date;
      _this.invoiceCreate.contract_end_date = param.contract_end_date;
      _this.invoiceCreate.funding_group_id = param.funding_group_id;
      _this.supplierId = param.funding_group_id;
      _this.invoiceCreate.copayment_amount = param.copayment_amount;
      _this.invoiceCreate.copayment_amount_type = param.copayment_amount_type;
      _this.invoiceCreate.copayment_perc = param.copayment_perc;
      _this.invoiceCreate.pro_rated_copayment_amount = param.pro_rated_copayment_amount;
      _this.invoiceCreate.consolidated_trips = param.consolidated_trips;
      _this.funding_billing_address = param?.funding_address?.property_address;
     

      _this.updateData.payment_terms = param.payment_terms;
      _this.updateData.term_conditions = param.term_conditions;
      _this.updateData.admin_remark = param.admin_remark;
      _this.updateData.client_remark = param.client_remark;
      _this.updateData.notify_admin = param.notify_admin;
      _this.updateData.notify_customer = param.notify_customer;
      _this.updateData.documents = param.documents;

      _this
        .getLineItems({
          invoice: _this.invoiceId,
          visit: _this.visitId,
        })
        .then((data) => {
          const result = [];
          for (let i = 0; i < data.length; i++) {
            result.push({
              id: data[i].id,
              group: data[i].group,
              group_primary: data[i].group_primary,
              product: data[i].product,
              product_id: data[i].product_id,
              serial_no: data[i].serial_no,
              eq_model: data[i].eq_model,
              location: data[i].location,
              product_type: data[i].product_type,
              has_warranty: data[i].has_warranty,
              warranty: data[i].warranty,
              description: data[i].description,
              rate: data[i].rate,
              quantity: data[i].quantity,
              uom: data[i].uom,
              total: data[i].total,
              visit_barcode: data[i].visit_barcode,
            });
          }

          _this.$nextTick(() => {
            _this.dbLineItems = filter(result, function (row) {
              return (
                row.product_type == "goods" || row.product_type == "service"
              );
            });
            _this.dbEquipments = filter(result, {
              product_type: "equipment",
            });
          });
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
    setDuplicateData(param) {
      const _this = this;

      _this.invoiceCreate.job_title = param.title;
      _this.invoiceCreate.property_person_notify = param.property_person_notify;
      _this.invoiceCreate.billing_person_notify = param.billing_person_notify;
      _this.invoiceCreate.reference = `Invoice # ${param.barcode}`;
      _this.invoiceCreate.issued_type = param.issued_type;
      _this.invoiceCreate.payment_due = param.payment_due;
      _this.invoiceCreate.discount_value = param.discount_value;
      _this.invoiceCreate.discount_value_type = param.discount_value_type;
      _this.invoiceCreate.tax_applied = param.tax_applied;
      _this.invoiceCreate.adjustment = param.adjustment;
      _this.invoiceCreate.invoice_date = param.invoice_date;
      _this.invoiceCreate.due_date = param.due_date;
      _this.invoiceCreate.attention = param.attention;

      _this.updateData.payment_terms = param.payment_terms;
      _this.updateData.term_conditions = param.term_conditions;
      _this.updateData.admin_remark = param.admin_remark;
      _this.updateData.client_remark = param.client_remark;
      _this.updateData.notify_admin = param.notify_admin;
      _this.updateData.notify_customer = param.notify_customer;
      _this.updateData.documents = [];

      _this
        .getLineItems({
          invoice: _this.duplicateInvoice,
          visit: _this.visitId,
        })
        .then((data) => {
          const result = [];
          for (let i = 0; i < data.length; i++) {
            result.push({
              id: null,
              group: data[i].group,
              group_primary: data[i].group_primary,
              product: data[i].product,
              product_id: data[i].product_id,
              serial_no: data[i].serial_no,
              eq_model: data[i].eq_model,
              location: data[i].location,
              product_type: data[i].product_type,
              has_warranty: data[i].has_warranty,
              warranty: data[i].warranty,
              description: data[i].description,
              rate: data[i].rate,
              quantity: data[i].quantity,
              uom: data[i].uom,
              total: data[i].total,
              visit_barcode: data[i].visit_barcode,
            });
          }

          _this.$nextTick(() => {
            _this.dbLineItems = filter(result, function (row) {
              return (
                row.product_type == "goods" || row.product_type == "service"
              );
            });
            _this.dbEquipments = filter(result, {
              product_type: "equipment",
            });
          });
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
    setTicketData(param) {
      const _this = this;

      _this.invoiceCreate.job_title = param.title;
      _this.invoiceCreate.property_person_notify = param.property_person_notify;
      _this.invoiceCreate.billing_person_notify = param.billing_person_notify;
      _this.invoiceCreate.reference = `Visit # ${param.barcode}`;
      _this.invoiceCreate.discount_value = param.discount_value;
      _this.invoiceCreate.discount_value_type = param.discount_value_type;
      _this.invoiceCreate.tax_applied = param.tax_applied;
      _this.invoiceCreate.adjustment = param.adjustment;
      _this.invoiceCreate.invoice_date = param.invoice_date;
      _this.invoiceCreate.due_date = param.due_date;
      _this.invoiceCreate.attention = param.attention;

      _this.updateData.payment_terms = param.payment_terms;
      _this.updateData.term_conditions = param.term_conditions;
      _this.updateData.admin_remark = param.admin_remark;
      _this.updateData.client_remark = param.client_remark;
      _this.updateData.notify_admin = param.notify_admin;
      _this.updateData.notify_customer = param.notify_customer;
      _this.updateData.documents = [];

      _this
        .getLineItems({
          job: _this.ticketId,
          visit: _this.visitId,
        })
        .then((data) => {
          const result = [];
          for (let i = 0; i < data.length; i++) {
            result.push({
              id: null,
              group: data[i].group,
              group_primary: data[i].group_primary,
              product: data[i].product,
              product_id: data[i].product_id,
              serial_no: data[i].serial_no,
              eq_model: data[i].eq_model,
              location: data[i].location,
              product_type: data[i].product_type,
              has_warranty: data[i].has_warranty,
              warranty: data[i].warranty,
              description: data[i].description,
              rate: data[i].rate,
              quantity: data[i].quantity,
              uom: data[i].uom,
              total: data[i].total,
              visit_barcode: data[i].visit_barcode,
            });
          }

          _this.$nextTick(() => {
            _this.dbLineItems = filter(result, function (row) {
              return (
                row.product_type == "goods" || row.product_type == "service"
              );
            });
            _this.dbEquipments = filter(result, {
              product_type: "equipment",
            });
          });
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
    setQuotationData(param) {
      const _this = this;

      _this.invoiceCreate.job_title = param.job_title;
      _this.invoiceCreate.property_person_notify = param.property_person_notify;
      _this.invoiceCreate.billing_person_notify = param.billing_person_notify;
      _this.invoiceCreate.reference = `Quotation # ${param.barcode}`;
      _this.invoiceCreate.discount_value = param.discount_value;
      _this.invoiceCreate.discount_value_type = param.discount_value_type;
      _this.invoiceCreate.tax_applied = param.tax_applied;
      _this.invoiceCreate.adjustment = param.adjustment;
      _this.invoiceCreate.invoice_date = param.invoice_date;
      _this.invoiceCreate.due_date = param.due_date;
      _this.invoiceCreate.attention = param.attention;

      _this.updateData.payment_terms = param.payment_terms;
      _this.updateData.term_conditions = param.term_conditions;
      _this.updateData.admin_remark = param.admin_remark;
      _this.updateData.client_remark = param.client_remark;
      _this.updateData.notify_admin = param.notify_admin;
      _this.updateData.notify_customer = param.notify_customer;
      _this.updateData.documents = [];

      _this
        .getLineItems({
          quotation: _this.quotationId,
          visit: _this.visitId,
        })
        .then((data) => {
          const result = [];
          for (let i = 0; i < data.length; i++) {
            result.push({
              id: null,
              group: data[i].group,
              group_primary: data[i].group_primary,
              product: data[i].product,
              product_id: data[i].product_id,
              serial_no: data[i].serial_no,
              eq_model: data[i].eq_model,
              location: data[i].location,
              product_type: data[i].product_type,
              has_warranty: data[i].has_warranty,
              warranty: data[i].warranty,
              description: data[i].description,
              rate: data[i].rate,
              quantity: data[i].quantity,
              uom: data[i].uom,
              total: data[i].total,
              visit_barcode: data[i].visit_barcode,
            });
          }

          _this.$nextTick(() => {
            _this.dbLineItems = filter(result, function (row) {
              return (
                row.product_type == "goods" || row.product_type == "service"
              );
            });
            _this.dbEquipments = filter(result, {
              product_type: "equipment",
            });
          });
        })
        .catch((error) => {
          _this.logError(error);
        });
    },

    getOptions() {
      this.pageLoading = true;
      this.$store
        .dispatch(QUERY, {
          url: "invoice/options",
          data: {
            invoice: this.invoiceId,
            customer: this.invoiceCustomer,
            
          },
        })

        .then(({ data }) => {
         
          this.uniqueId = Number(new Date());
          this.updateData.term_conditions = data.options.terms_conditions;
          this.updateData.admin_remark = data.options.client_note;
          this.updateData.client_remark = data.options.admin_note;
          this.paymentTypeList = data.payment_types;
          this.fundingOrganisations = data.funding_organisations;
          if (data.user && data.user.full_name) {
            this.quotationCreate.prepared_by = data.user.full_name;
          }
          if (data.barcode) {
            this.invoiceCreate.barcode = data.barcode;
          }

          if (!isEmpty(data.payment_terms)) {
            this.paymentDueList = data.payment_terms;
          }

          if (!isEmpty(data.options)) {
            this.barcodeSetting = data.options;
            this.updateData.term_conditions =
              this.barcodeSetting.terms_conditions;
          }

         
          if (!isEmpty(data.quotation)) {
            this.setQuotationData(data.quotation);
          }

          if (!isEmpty(data.ticket)) {
            this.setTicketData(data.ticket);
          }

          if (!isEmpty(data.duplicate)) {
            this.setDuplicateData(data.duplicate);
          }

          if (!isEmpty(data.customer)) {


            this.customer = data.customer;

            const addresses = data.customer?.address;
           
            if(addresses && addresses.length == 2)  
            {
                this.property = addresses[0];  
                this.billing  = addresses[0];
                
            }

            else if (addresses && addresses.length > 2) {
             
              this.property = addresses.find(addr => addr.type === 1);
              this.billing  = addresses.find(addr => addr.type === 2);

              if(!this.billing)
              {
                  this.billing = addresses[0];
              }

               if(!this.property)
              {
                  this.property = addresses[0];
              }

            }
            
            this.invoiceBilling = this.billing.id;

            this.invoiceProperty = this.property.id;

            this.property_contact_person = data.customer?.default_person;
            this.invoiceCreate.attention = this.property_contact_person?.display_name;
            this.invoicePropertyPerson = this.property_contact_person?.id;


            this.billing_contact_person = data.customer?.default_person;
            this.invoiceBillingPerson = this.billing_contact_person?.id;

            this.invoiceCustomer = this.customer.id;

            if(!this.invoiceId)
            {

              this.invoiceCreate.payment_type = data.customer.payment_type;
              const  ongoingOrganisation = this.fundingOrganisation;
            
              
              if(!ongoingOrganisation)
              {
                this.showContractAlert = true;
              }

              if(ongoingOrganisation)
              {
               
                 this.supplierId = ongoingOrganisation?.funding_group_id || 0;
                 this.invoiceCreate.funding_organisation = ongoingOrganisation?.funding_organisation;
                 this.invoiceCreate.funding_group_id = ongoingOrganisation?.funding_group_id || 0;
                 this.invoiceCreate.contract_start_date = ongoingOrganisation?.contract_start_date;
                 this.invoiceCreate.contract_end_date = ongoingOrganisation?.contract_end_date;

                if(ongoingOrganisation?.copayment_amount_type == '1')
                {
                this.invoiceCreate.copayment_amount = ongoingOrganisation?.copayment_amount;
                }

                if(ongoingOrganisation?.copayment_amount_type == '2')
                {

                  this.invoiceCreate.copayment_perc = ongoingOrganisation?.copayment_amount;
               
                }
               
                this.invoiceCreate.copayment_amount_type = ongoingOrganisation?.copayment_amount_type;


              }
            
            }
           
          }

           if (!isEmpty(data.invoice)) {
            this.isUpdate = true;
            this.setUpdateData(data.invoice);
          }

          if (!isEmpty(data.billing)) {
            this.billing = data.billing;
            this.invoiceBilling = this.billing.id;
          }

          if (!isEmpty(data.property)) {
            this.property = data.property;
            this.invoiceProperty = this.property.id;
          }

          if (!isEmpty(data.property_person)) {
            this.property_contact_person = data.property_person;
            this.invoiceCreate.attention = this.property_contact_person?.display_name;
            this.invoicePropertyPerson = this.property_contact_person.id;
          }

          if (!isEmpty(data.billing_person)) {
            this.billing_contact_person = data.billing_person;
            this.invoiceBillingPerson = this.billing_contact_person.id;
          }
        })
        .catch((error) => {
          this.logError(error);
          this.goBack();
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
  },

  mounted() {

   
    if(this.invoiceId > 0)
    {
       this.$store.dispatch(SET_BREADCRUMB, [
        { title: "Invoice", route: "invoice" },
        { title: "Update" },
      ]);
    }

    else{

        this.$store.dispatch(SET_BREADCRUMB, [
          { title: "Invoice", route: "invoice" },
          { title: "Create" },
        ]);

    }


    this.getOptions();

     if(!this.invoiceId)
    {

      this.selectedTransports = [...this.reSelectedTransport];
        const total = (this.selectedTransports || []).reduce(
          (sum, transport) => sum + (parseFloat(transport.number_of_trips) || 0),
           0
          );

        this.invoiceCreate.consolidated_trips = parseFloat(total.toFixed(2));
        this.funding_billing_address = this.fundingOrganisation?.address?.property_address;
    }
    
    

    TermConditionEventBus.$on("update:payment-terms", (argument) => {
      this.paymentTerms = argument;
    });

    TermConditionEventBus.$on("update:term-condition", (argument) => {
      this.termsCondition = argument;
    });

    NoteAttachmentEventBus.$on("update:notes-attachment", (argument) => {
      this.noteAttachment = argument;
    });
  },
   watch: {

     subtotal(subTotal) {
      this.updateCopaymentAmount(subTotal);
    },

    'invoiceCreate.payment_type': {
      deep: true,
      immediate: true,
      handler(param) {
        const payment_type = param?.toLowerCase().replace(/[^a-z0-9]/g, '');
        if (payment_type === 'selffunded') {

            this.invoiceCreate.funding_organisation = null;
            this.invoiceCreate.copayment_amount = null;
            this.invoiceCreate.pro_rated_copayment_amount = null;
        }
      },


    },

    'invoiceCreate.copayment_amount': {
      deep: true,
      immediate: true,
      handler() {
        
        const amount = parseFloat(this.invoiceCreate.copayment_amount) || 0;
        const trips = parseFloat(this.invoiceCreate.consolidated_trips) || 0;

        if(this.invoiceCreate.funding_organisation?.toLowerCase() === 'nkf' && trips !== 13){

          this.invoiceCreate.pro_rated_copayment_amount = parseFloat(((amount / 13) * trips).toFixed(2));

        }

      },

    },
  },  
  beforeMount() {
    this.invoiceId = toSafeInteger(this.$route.params.id);
    this.invoiceCustomer = toSafeInteger(this.$route.query.customer);
    this.invoiceBilling = toSafeInteger(this.$route.query.billing);
    this.invoiceProperty = toSafeInteger(this.$route.query.property);
    this.invoicePropertyPerson = toSafeInteger(
      this.$route.query.property_person
    );
    this.invoiceBillingPerson = toSafeInteger(this.$route.query.billing_person);
    this.duplicateInvoice = toSafeInteger(this.$route.query.duplicate);
    this.ticketId = toSafeInteger(this.$route.query.ticket);
    this.visitId = toSafeInteger(this.$route.query.visit);
    this.quotationId = toSafeInteger(this.$route.query.quotation);
  },
  beforeRouteLeave(to, from, next) {
    const _this = this;
    if (_this.forcePush) {
      next();
    } else if (_this.invoiceCreated) {
      next();
    } else {
      _this.routePreventDialog = true;
      PreventDialogEventBus.$on("stay-on-page", function () {
        _this.routePreventDialog = false;
        next(false);
      });
      PreventDialogEventBus.$on("leave-page", function () {
        _this.routePreventDialog = false;
        next();
      });
    }
  },
   computed: {
      ...mapGetters(["fundingOrganisation","reSelectedTransport","vSelectedLineItem","vCalculations"]),

        formattedDate() {
      if (
        this.invoiceCreate.contract_start_date &&
        this.invoiceCreate.contract_end_date
      ) {
        const start = this.invoiceCreate.contract_start_date;
        const end   = this.invoiceCreate.contract_end_date;

        return `${this.formatDate(start)} - ${this.formatDate(end)}`;

      }
      return '';
    }
  },
};
</script>
